export default {
  title: 'Nebula buds AI Samtal', // "Nebula buds AI通话" 翻译为瑞典语
  userID: 'Användar-ID : ', // "用户ID : "
  hurryUp: 'Väntar på samtal från den andra parten', // "等待对方呼叫"
  waitingCall: 'Väntar på samtal från den andra parten på denna sida, vänligen stäng inte sidan för tidigt.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Undertextbrytare', // "字幕开关"
  initWait: 'Väntar på initiering', // "等待初始化"
  initSuccess: 'Initiering klar, väntar på samtal från den andra parten. Vänligen stäng inte sidan!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Samtal anslutet', // "电话接通"
  callEnd: 'Samtal avslutat', // "通话结束"
  careful: 'Varning : ', // "注意 : "
  wait: 'Samtalskomponent klar, väntar på samtal från den andra parten', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Arabiska', // "阿拉伯语"
    da: 'Danska', // "丹麦语"
    de: 'Tyska', // "德语"
    en: 'Engelska', // "英语"
    es: 'Spanska', // "西班牙语"
    fil: 'Filippinska', // "菲律宾语"
    fr: 'Franska', // "法语"
    hi: 'Hindi', // "印地语"
    id: 'Indonesiska', // "印度尼西亚语"
    it: 'Italienska', // "意大利语"
    ja: 'Japanska', // "日文"
    ko: 'Koreanska', // "韩语"
    ms: 'Malaysiska', // "马来语"
    no: 'Norska', // "挪威语"
    pt: 'Portugisiska', // "葡萄牙语"
    ru: 'Ryska', // "俄语"
    sv: 'Svenska', // "瑞典语"
    th: 'Thailändska', // "泰语"
    tr: 'Turkiska', // "土耳其语"
    vi: 'Vietnamesiska', // "越南语"
    zh: 'Kinesiska' // "中文"
  }
}
